module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAAuUlEQVQYlY2PPQrCQBCFx6yxDENIGruAHkJPoSfQNocSwZ8zeBczE7cZu6TIso2QXSslwhJ8MNW8D94HEIj3Pq6q6ua9j0P/YJj5bIxxRHT6CyCiXdM0xlrr27Y1RLQfBbTWhYhU1lr/ORG5a62LYS8aeEydc1dEXAwLiLjs+/4y9PtCdV0fsyxbhRbkeb5m5sMPxMwlIm6UUsHZSilI03TLzCUAwEREHkmSzKIomo8KA4Bz7tl13esNe3Fk7lhH3fQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/img/reviewIco3.png
// module id = FyF+
// module chunks = 25